export default __webpack_public_path__ + "static/media/diagnostic-bg.37d9fda7.jpg";